import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/contract',
	components: () => [import(/* webpackChunkName: 'contract' */ './component')],
	render: ([Event]) => <Event />,
};

export default routes;
